module.exports = __webpack_public_path__ + "img/hotel.18fdb06c.png";